"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PauseIcon = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var PauseIcon = function PauseIcon(props) {
  return (0, jsx_runtime_1.jsxs)("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64",
    height: "64",
    viewBox: "0 0 47.6 47.6"
  }, props, {
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M18 41c0 3.7-3 6.6-6.6 6.6l0 0c-3.7 0-6.6-3-6.6-6.6V6.6C4.7 3 7.7 0 11.4 0l0 0c3.7 0 6.6 3 6.6 6.6V41z"
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M42.9 41c0 3.7-3 6.6-6.6 6.6l0 0c-3.7 0-6.6-3-6.6-6.6V6.6C29.6 3 32.6 0 36.2 0l0 0c3.7 0 6.6 3 6.6 6.6V41z"
    }, void 0)]
  }), void 0);
};

exports.PauseIcon = PauseIcon;